import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import CopyToClipboard from 'react-copy-to-clipboard'
import callAPI from '../../../helpers/callAPI'
import Campaign from '../../../templates/Campaign/Campaign'
import Loading from '../../../templates/UI/Loading/Loading'
import DownloadCSV from '../../../templates/DownloadCSV/DownloadCSV'
import useDownloadCSV from '../../../hooks/useDownloadCSV'
import { useAuth, useProtectedContent } from '../../../context/AuthContext'
import AffiliateNavbar from '../Templates/AffiliateNavbar/AffiliateNavbar'
import useCallApi from '../../../hooks/useCallApi'
import moment from 'moment'

const DEFAULT_DAYS = 30

const PullBulkLinks = ({ affiliateId, showSystemMessage }) => {
    document.title = 'Get Bulk Links'

    const auth = useAuth()
    const showPullBulkLinks = useProtectedContent(auth.permissions, 'pull_bulk_links')

    const [links, setLinks] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)
    const [days, setDays] = useState(DEFAULT_DAYS)

    const { dataLoaded: affDataLoaded, data: affData, setData: setAffData, refetch: affRefetch } = useCallApi(`affiliate/${affiliateId}`, 'GET', {}, [], showSystemMessage)

    const { CSVFilename, setCSVFilename, CSVHeaderLabels, setCSVHeaderLabels, CSVDataLabels, setCSVDataLabels, CSVReport, setCSVReport } = useDownloadCSV()

    const fetchBulkLinks = () => {
        setDataLoaded(false)
        const url = `affiliate/${affiliateId}/bulkLinks?days=${days}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result.success && Array.isArray(result.links)) {
                    if (result.links.length == 0) {
                        console.log('no links found')
                    } else {
                    setLinks(result.links)
                    setCSVReport(result.links)
                        setCSVFilename(`Pull-Bulk-Links-${affData.affiliate.name}-${affiliateId}-start_date-${moment().subtract(days, 'days').format('YYYY-MM-DD')}-end_date-${moment().format('YYYY-MM-DD')}`)
                        setCSVHeaderLabels(['Campaign ID', 'Campaign Name', 'URL'])
                        setCSVDataLabels(['campaign_id', 'campaign_name', 'url'])
                    }
                } else {
                    setLinks([])
                    setCSVReport([])
                    if (result.success === false && result.errors && result.errors.message) {
                        showSystemMessage('error', result.errors.message)
                    } else {
                        showSystemMessage('error', 'Could not load bulk links.')
                    }
                }
                setDataLoaded(true)
            })
            .catch((error) => {
                showSystemMessage('error', 'An error occurred while fetching bulk links.')
                setLinks([])
                setCSVReport([])
                setDataLoaded(true)
            })
    }

    useEffect(() => {
        if (affDataLoaded && affiliateId && showPullBulkLinks) {
            fetchBulkLinks()
        }
    }, [affDataLoaded, affiliateId])

    if (!showPullBulkLinks) {
        return (
            <React.Fragment>
                <div className="page-header d-flex align-items-center">
                    <h1 className="mb-h1">Get Traffic Links</h1>
                </div>
                <div className="card mb-3">
                    <div className="card-body">
                        <p className="mb-0">You do not have access to this page.</p>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Get Traffic Links</h1>
                <div className="ml-5">
                    <AffiliateNavbar affiliateId={affiliateId} />
                </div>
            </div>
           
            <div className="card mb-3">
            <div className="-flex align-items-center flex-wrap">
                <div className="m-3 d-flex align-items-center flex-wrap">
                    <Form.Group className="mb-0 mr-2 d-flex align-items-center">
                        <Form.Label className="mb-0 mr-2">Lookback days</Form.Label>
                        <Form.Control
                            type="number"
                            defaultValue={DEFAULT_DAYS}
                            onChange={(e) => setDays(Number(e.target.value) || DEFAULT_DAYS)}
                            style={{ width: '80px' }}
                        />
                    </Form.Group>
                    <Button variant="primary" size="sm" onClick={fetchBulkLinks} className="mr-2">
                        Apply
                    </Button>
                    {dataLoaded && links.length > 0 && (
                        <DownloadCSV
                            filename={CSVFilename}
                            headerLabels={CSVHeaderLabels}
                            data={CSVReport}
                            dataLabels={CSVDataLabels}
                        />
                    )}
                </div>
            </div>
                <div className="card-body p-0">
                    {dataLoaded ? (
                        links.length === 0 ? (
                            <div className="p-3">No links available.</div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped table-card m-0">
                                    <thead>
                                        <tr>
                                            <th>Campaign</th>
                                            <th>URL</th>
                                            <th className="text-right">Copy</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {links.map((link, index) => (
                                            <tr key={`${link.campaign_id}-${link.landing_page_id || 0}-${index}`}>
                                                <td>
                                                    <Campaign
                                                        oid={link.campaign_id}
                                                        name={link.campaign_name || ''}
                                                        status={link.campaign_status}
                                                    />
                                                </td>
                                                <td className="text-break" style={{ maxWidth: '400px' }}>
                                                    <a href={link.url} target="_blank" rel="noopener noreferrer" className="text-truncate d-inline-block" style={{ maxWidth: '100%' }}>
                                                        {link.url}
                                                    </a>
                                                </td>
                                                <td className="text-right">
                                                    <CopyToClipboard text={link.url || ''} onCopy={() => showSystemMessage('success', 'Link copied to clipboard')}>
                                                        <Button variant="outline-primary" size="sm" className="shadow-none">
                                                            <FontAwesomeIcon icon={faCopy} />
                                                        </Button>
                                                    </CopyToClipboard>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                    ) : (
                        <Loading />
                    )}
                </div>
            </div>
        </div>
    )
}

export default PullBulkLinks
